import { render, staticRenderFns } from "./SidebarUserMenu.vue?vue&type=template&id=69d8058c"
import script from "./SidebarUserMenu.vue?vue&type=script&lang=js"
export * from "./SidebarUserMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports